const API_URL = () => document.querySelector('meta[name="api-root-endpoint"]').getAttribute('content') || 'http://localhost:3000/api/v1'

const checkVersion = (response) => {
  if (!response) return

  if (response.status === 401 && response.data?.errors === "Token is from an outdated version. Please refresh the page.") {
    window.location.reload()
  }
}

export {
  API_URL,
  checkVersion,
}
